

/// <reference path="OnlineItem.ts" />

// Generated class OnlineProduct_ManagedObject

class OnlineProduct_ManagedObject extends OnlineItem
{
    // Relationship: product
    set product(value:Product) {
        this.setValueForKey(value, 'product');
    }
    get product():Product {
        return this.valueForKey('product') as Product;
    }
}
